/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BillingRouteImport } from './routes/billing'
import { Route as CompleteProfileRouteImport } from './routes/complete-profile'
import { Route as ConfirmEmailRouteImport } from './routes/confirm-email'
import { Route as ContractorsRouteImport } from './routes/contractors'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as DesignSystemRouteImport } from './routes/design-system'
import { Route as DetectRouteImport } from './routes/detect'
import { Route as EmailTemplatesRouteImport } from './routes/email-templates'
import { Route as KonzeptRouteImport } from './routes/konzept'
import { Route as LanguageTestRouteImport } from './routes/language-test'
import { Route as LoginRouteImport } from './routes/login'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SetupPasswordRouteImport } from './routes/setup-password'
import { Route as SystemSettingsRouteImport } from './routes/system-settings'
import { Route as UpgradeRouteImport } from './routes/upgrade'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminAiTrainingRouteImport } from './routes/admin/ai-training'
import { Route as AdminReminderSettingsRouteImport } from './routes/admin/reminder-settings'
import { Route as AdminTelegramRouteImport } from './routes/admin/telegram'
import { Route as AdminTesterFeedbackRouteImport } from './routes/admin/tester-feedback'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as BoardLinkTokenRouteImport } from './routes/board-link/$token'
import { Route as CheckoutIndexRouteImport } from './routes/checkout/index'
import { Route as CheckoutSuccessRouteImport } from './routes/checkout/success'
import { Route as HistoryIndexRouteImport } from './routes/history/index'
import { Route as HistoryIdRouteImport } from './routes/history/$id'
import { Route as ProjectsIndexRouteImport } from './routes/projects/index'
import { Route as SlidesIndexRouteImport } from './routes/slides/index'
import { Route as SlidesAdmRouteImport } from './routes/slides/adm'
import { Route as SolutionsIndexRouteImport } from './routes/solutions/index'
import { Route as SolutionsDefectTypeRouteImport } from './routes/solutions/$defectType'
import { Route as TicketsIndexRouteImport } from './routes/tickets/index'
import { Route as TicketsIdRouteImport } from './routes/tickets/$id'
import { Route as ProjectsIdIndexRouteImport } from './routes/projects/$id/index'
import { Route as ProjectsIdAnalysesRouteImport } from './routes/projects/$id/analyses'
import { Route as ProjectsIdBoardRouteImport } from './routes/projects/$id/board'
import { Route as ProjectsIdFloorplanRouteImport } from './routes/projects/$id/floorplan'
import { Route as ProjectsIdSettingsRouteImport } from './routes/projects/$id/settings'
import { Route as ProjectsIdTeamRouteImport } from './routes/projects/$id/team'
import { Route as ProjectsIdTicketsRouteImport } from './routes/projects/$id/tickets'
import { Route as TicketSubmitIdIndexRouteImport } from './routes/ticket-submit/$id/index'
import { Route as TicketSubmitIdCompletedRouteImport } from './routes/ticket-submit/$id/completed'
import { Route as ProjectsIdInspectionsIndexRouteImport } from './routes/projects/$id/inspections/index'
import { Route as ProjectsIdInspectionsInspectionIdRouteImport } from './routes/projects/$id/inspections/$inspectionId'
import { Route as ProjectsIdInspectionsNewRouteImport } from './routes/projects/$id/inspections/new'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingRoute = BillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => rootRouteImport,
} as any)
const CompleteProfileRoute = CompleteProfileRouteImport.update({
  id: '/complete-profile',
  path: '/complete-profile',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfirmEmailRoute = ConfirmEmailRouteImport.update({
  id: '/confirm-email',
  path: '/confirm-email',
  getParentRoute: () => rootRouteImport,
} as any)
const ContractorsRoute = ContractorsRouteImport.update({
  id: '/contractors',
  path: '/contractors',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const DesignSystemRoute = DesignSystemRouteImport.update({
  id: '/design-system',
  path: '/design-system',
  getParentRoute: () => rootRouteImport,
} as any)
const DetectRoute = DetectRouteImport.update({
  id: '/detect',
  path: '/detect',
  getParentRoute: () => rootRouteImport,
} as any)
const EmailTemplatesRoute = EmailTemplatesRouteImport.update({
  id: '/email-templates',
  path: '/email-templates',
  getParentRoute: () => rootRouteImport,
} as any)
const KonzeptRoute = KonzeptRouteImport.update({
  id: '/konzept',
  path: '/konzept',
  getParentRoute: () => rootRouteImport,
} as any)
const LanguageTestRoute = LanguageTestRouteImport.update({
  id: '/language-test',
  path: '/language-test',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SetupPasswordRoute = SetupPasswordRouteImport.update({
  id: '/setup-password',
  path: '/setup-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemSettingsRoute = SystemSettingsRouteImport.update({
  id: '/system-settings',
  path: '/system-settings',
  getParentRoute: () => rootRouteImport,
} as any)
const UpgradeRoute = UpgradeRouteImport.update({
  id: '/upgrade',
  path: '/upgrade',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAiTrainingRoute = AdminAiTrainingRouteImport.update({
  id: '/admin/ai-training',
  path: '/admin/ai-training',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminReminderSettingsRoute = AdminReminderSettingsRouteImport.update({
  id: '/admin/reminder-settings',
  path: '/admin/reminder-settings',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTelegramRoute = AdminTelegramRouteImport.update({
  id: '/admin/telegram',
  path: '/admin/telegram',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTesterFeedbackRoute = AdminTesterFeedbackRouteImport.update({
  id: '/admin/tester-feedback',
  path: '/admin/tester-feedback',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => rootRouteImport,
} as any)
const BoardLinkTokenRoute = BoardLinkTokenRouteImport.update({
  id: '/board-link/$token',
  path: '/board-link/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutIndexRoute = CheckoutIndexRouteImport.update({
  id: '/checkout/',
  path: '/checkout/',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutSuccessRoute = CheckoutSuccessRouteImport.update({
  id: '/checkout/success',
  path: '/checkout/success',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryIndexRoute = HistoryIndexRouteImport.update({
  id: '/history/',
  path: '/history/',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryIdRoute = HistoryIdRouteImport.update({
  id: '/history/$id',
  path: '/history/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsIndexRoute = ProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => rootRouteImport,
} as any)
const SlidesIndexRoute = SlidesIndexRouteImport.update({
  id: '/slides/',
  path: '/slides/',
  getParentRoute: () => rootRouteImport,
} as any)
const SlidesAdmRoute = SlidesAdmRouteImport.update({
  id: '/slides/adm',
  path: '/slides/adm',
  getParentRoute: () => rootRouteImport,
} as any)
const SolutionsIndexRoute = SolutionsIndexRouteImport.update({
  id: '/solutions/',
  path: '/solutions/',
  getParentRoute: () => rootRouteImport,
} as any)
const SolutionsDefectTypeRoute = SolutionsDefectTypeRouteImport.update({
  id: '/solutions/$defectType',
  path: '/solutions/$defectType',
  getParentRoute: () => rootRouteImport,
} as any)
const TicketsIndexRoute = TicketsIndexRouteImport.update({
  id: '/tickets/',
  path: '/tickets/',
  getParentRoute: () => rootRouteImport,
} as any)
const TicketsIdRoute = TicketsIdRouteImport.update({
  id: '/tickets/$id',
  path: '/tickets/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsIdIndexRoute = ProjectsIdIndexRouteImport.update({
  id: '/projects/$id/',
  path: '/projects/$id/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsIdAnalysesRoute = ProjectsIdAnalysesRouteImport.update({
  id: '/projects/$id/analyses',
  path: '/projects/$id/analyses',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsIdBoardRoute = ProjectsIdBoardRouteImport.update({
  id: '/projects/$id/board',
  path: '/projects/$id/board',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsIdFloorplanRoute = ProjectsIdFloorplanRouteImport.update({
  id: '/projects/$id/floorplan',
  path: '/projects/$id/floorplan',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsIdSettingsRoute = ProjectsIdSettingsRouteImport.update({
  id: '/projects/$id/settings',
  path: '/projects/$id/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsIdTeamRoute = ProjectsIdTeamRouteImport.update({
  id: '/projects/$id/team',
  path: '/projects/$id/team',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsIdTicketsRoute = ProjectsIdTicketsRouteImport.update({
  id: '/projects/$id/tickets',
  path: '/projects/$id/tickets',
  getParentRoute: () => rootRouteImport,
} as any)
const TicketSubmitIdIndexRoute = TicketSubmitIdIndexRouteImport.update({
  id: '/ticket-submit/$id/',
  path: '/ticket-submit/$id/',
  getParentRoute: () => rootRouteImport,
} as any)
const TicketSubmitIdCompletedRoute = TicketSubmitIdCompletedRouteImport.update({
  id: '/ticket-submit/$id/completed',
  path: '/ticket-submit/$id/completed',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsIdInspectionsIndexRoute =
  ProjectsIdInspectionsIndexRouteImport.update({
    id: '/projects/$id/inspections/',
    path: '/projects/$id/inspections/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProjectsIdInspectionsInspectionIdRoute =
  ProjectsIdInspectionsInspectionIdRouteImport.update({
    id: '/projects/$id/inspections/$inspectionId',
    path: '/projects/$id/inspections/$inspectionId',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProjectsIdInspectionsNewRoute =
  ProjectsIdInspectionsNewRouteImport.update({
    id: '/projects/$id/inspections/new',
    path: '/projects/$id/inspections/new',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/billing': typeof BillingRoute
  '/complete-profile': typeof CompleteProfileRoute
  '/confirm-email': typeof ConfirmEmailRoute
  '/contractors': typeof ContractorsRoute
  '/dashboard': typeof DashboardRoute
  '/design-system': typeof DesignSystemRoute
  '/detect': typeof DetectRoute
  '/email-templates': typeof EmailTemplatesRoute
  '/konzept': typeof KonzeptRoute
  '/language-test': typeof LanguageTestRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/setup-password': typeof SetupPasswordRoute
  '/system-settings': typeof SystemSettingsRoute
  '/upgrade': typeof UpgradeRoute
  '/admin/ai-training': typeof AdminAiTrainingRoute
  '/admin/reminder-settings': typeof AdminReminderSettingsRoute
  '/admin/telegram': typeof AdminTelegramRoute
  '/admin/tester-feedback': typeof AdminTesterFeedbackRoute
  '/admin/users': typeof AdminUsersRoute
  '/board-link/$token': typeof BoardLinkTokenRoute
  '/checkout/success': typeof CheckoutSuccessRoute
  '/history/$id': typeof HistoryIdRoute
  '/slides/adm': typeof SlidesAdmRoute
  '/solutions/$defectType': typeof SolutionsDefectTypeRoute
  '/tickets/$id': typeof TicketsIdRoute
  '/admin/': typeof AdminIndexRoute
  '/checkout/': typeof CheckoutIndexRoute
  '/history/': typeof HistoryIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/slides/': typeof SlidesIndexRoute
  '/solutions/': typeof SolutionsIndexRoute
  '/tickets/': typeof TicketsIndexRoute
  '/projects/$id/analyses': typeof ProjectsIdAnalysesRoute
  '/projects/$id/board': typeof ProjectsIdBoardRoute
  '/projects/$id/floorplan': typeof ProjectsIdFloorplanRoute
  '/projects/$id/settings': typeof ProjectsIdSettingsRoute
  '/projects/$id/team': typeof ProjectsIdTeamRoute
  '/projects/$id/tickets': typeof ProjectsIdTicketsRoute
  '/ticket-submit/$id/completed': typeof TicketSubmitIdCompletedRoute
  '/projects/$id/': typeof ProjectsIdIndexRoute
  '/ticket-submit/$id/': typeof TicketSubmitIdIndexRoute
  '/projects/$id/inspections/$inspectionId': typeof ProjectsIdInspectionsInspectionIdRoute
  '/projects/$id/inspections/new': typeof ProjectsIdInspectionsNewRoute
  '/projects/$id/inspections/': typeof ProjectsIdInspectionsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/billing': typeof BillingRoute
  '/complete-profile': typeof CompleteProfileRoute
  '/confirm-email': typeof ConfirmEmailRoute
  '/contractors': typeof ContractorsRoute
  '/dashboard': typeof DashboardRoute
  '/design-system': typeof DesignSystemRoute
  '/detect': typeof DetectRoute
  '/email-templates': typeof EmailTemplatesRoute
  '/konzept': typeof KonzeptRoute
  '/language-test': typeof LanguageTestRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/setup-password': typeof SetupPasswordRoute
  '/system-settings': typeof SystemSettingsRoute
  '/upgrade': typeof UpgradeRoute
  '/admin/ai-training': typeof AdminAiTrainingRoute
  '/admin/reminder-settings': typeof AdminReminderSettingsRoute
  '/admin/telegram': typeof AdminTelegramRoute
  '/admin/tester-feedback': typeof AdminTesterFeedbackRoute
  '/admin/users': typeof AdminUsersRoute
  '/board-link/$token': typeof BoardLinkTokenRoute
  '/checkout/success': typeof CheckoutSuccessRoute
  '/history/$id': typeof HistoryIdRoute
  '/slides/adm': typeof SlidesAdmRoute
  '/solutions/$defectType': typeof SolutionsDefectTypeRoute
  '/tickets/$id': typeof TicketsIdRoute
  '/admin': typeof AdminIndexRoute
  '/checkout': typeof CheckoutIndexRoute
  '/history': typeof HistoryIndexRoute
  '/projects': typeof ProjectsIndexRoute
  '/slides': typeof SlidesIndexRoute
  '/solutions': typeof SolutionsIndexRoute
  '/tickets': typeof TicketsIndexRoute
  '/projects/$id/analyses': typeof ProjectsIdAnalysesRoute
  '/projects/$id/board': typeof ProjectsIdBoardRoute
  '/projects/$id/floorplan': typeof ProjectsIdFloorplanRoute
  '/projects/$id/settings': typeof ProjectsIdSettingsRoute
  '/projects/$id/team': typeof ProjectsIdTeamRoute
  '/projects/$id/tickets': typeof ProjectsIdTicketsRoute
  '/ticket-submit/$id/completed': typeof TicketSubmitIdCompletedRoute
  '/projects/$id': typeof ProjectsIdIndexRoute
  '/ticket-submit/$id': typeof TicketSubmitIdIndexRoute
  '/projects/$id/inspections/$inspectionId': typeof ProjectsIdInspectionsInspectionIdRoute
  '/projects/$id/inspections/new': typeof ProjectsIdInspectionsNewRoute
  '/projects/$id/inspections': typeof ProjectsIdInspectionsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/billing': typeof BillingRoute
  '/complete-profile': typeof CompleteProfileRoute
  '/confirm-email': typeof ConfirmEmailRoute
  '/contractors': typeof ContractorsRoute
  '/dashboard': typeof DashboardRoute
  '/design-system': typeof DesignSystemRoute
  '/detect': typeof DetectRoute
  '/email-templates': typeof EmailTemplatesRoute
  '/konzept': typeof KonzeptRoute
  '/language-test': typeof LanguageTestRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/setup-password': typeof SetupPasswordRoute
  '/system-settings': typeof SystemSettingsRoute
  '/upgrade': typeof UpgradeRoute
  '/admin/ai-training': typeof AdminAiTrainingRoute
  '/admin/reminder-settings': typeof AdminReminderSettingsRoute
  '/admin/telegram': typeof AdminTelegramRoute
  '/admin/tester-feedback': typeof AdminTesterFeedbackRoute
  '/admin/users': typeof AdminUsersRoute
  '/board-link/$token': typeof BoardLinkTokenRoute
  '/checkout/success': typeof CheckoutSuccessRoute
  '/history/$id': typeof HistoryIdRoute
  '/slides/adm': typeof SlidesAdmRoute
  '/solutions/$defectType': typeof SolutionsDefectTypeRoute
  '/tickets/$id': typeof TicketsIdRoute
  '/admin/': typeof AdminIndexRoute
  '/checkout/': typeof CheckoutIndexRoute
  '/history/': typeof HistoryIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/slides/': typeof SlidesIndexRoute
  '/solutions/': typeof SolutionsIndexRoute
  '/tickets/': typeof TicketsIndexRoute
  '/projects/$id/analyses': typeof ProjectsIdAnalysesRoute
  '/projects/$id/board': typeof ProjectsIdBoardRoute
  '/projects/$id/floorplan': typeof ProjectsIdFloorplanRoute
  '/projects/$id/settings': typeof ProjectsIdSettingsRoute
  '/projects/$id/team': typeof ProjectsIdTeamRoute
  '/projects/$id/tickets': typeof ProjectsIdTicketsRoute
  '/ticket-submit/$id/completed': typeof TicketSubmitIdCompletedRoute
  '/projects/$id/': typeof ProjectsIdIndexRoute
  '/ticket-submit/$id/': typeof TicketSubmitIdIndexRoute
  '/projects/$id/inspections/$inspectionId': typeof ProjectsIdInspectionsInspectionIdRoute
  '/projects/$id/inspections/new': typeof ProjectsIdInspectionsNewRoute
  '/projects/$id/inspections/': typeof ProjectsIdInspectionsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/billing'
    | '/complete-profile'
    | '/confirm-email'
    | '/contractors'
    | '/dashboard'
    | '/design-system'
    | '/detect'
    | '/email-templates'
    | '/konzept'
    | '/language-test'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/setup-password'
    | '/system-settings'
    | '/upgrade'
    | '/admin/ai-training'
    | '/admin/reminder-settings'
    | '/admin/telegram'
    | '/admin/tester-feedback'
    | '/admin/users'
    | '/board-link/$token'
    | '/checkout/success'
    | '/history/$id'
    | '/slides/adm'
    | '/solutions/$defectType'
    | '/tickets/$id'
    | '/admin/'
    | '/checkout/'
    | '/history/'
    | '/projects/'
    | '/slides/'
    | '/solutions/'
    | '/tickets/'
    | '/projects/$id/analyses'
    | '/projects/$id/board'
    | '/projects/$id/floorplan'
    | '/projects/$id/settings'
    | '/projects/$id/team'
    | '/projects/$id/tickets'
    | '/ticket-submit/$id/completed'
    | '/projects/$id/'
    | '/ticket-submit/$id/'
    | '/projects/$id/inspections/$inspectionId'
    | '/projects/$id/inspections/new'
    | '/projects/$id/inspections/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/billing'
    | '/complete-profile'
    | '/confirm-email'
    | '/contractors'
    | '/dashboard'
    | '/design-system'
    | '/detect'
    | '/email-templates'
    | '/konzept'
    | '/language-test'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/setup-password'
    | '/system-settings'
    | '/upgrade'
    | '/admin/ai-training'
    | '/admin/reminder-settings'
    | '/admin/telegram'
    | '/admin/tester-feedback'
    | '/admin/users'
    | '/board-link/$token'
    | '/checkout/success'
    | '/history/$id'
    | '/slides/adm'
    | '/solutions/$defectType'
    | '/tickets/$id'
    | '/admin'
    | '/checkout'
    | '/history'
    | '/projects'
    | '/slides'
    | '/solutions'
    | '/tickets'
    | '/projects/$id/analyses'
    | '/projects/$id/board'
    | '/projects/$id/floorplan'
    | '/projects/$id/settings'
    | '/projects/$id/team'
    | '/projects/$id/tickets'
    | '/ticket-submit/$id/completed'
    | '/projects/$id'
    | '/ticket-submit/$id'
    | '/projects/$id/inspections/$inspectionId'
    | '/projects/$id/inspections/new'
    | '/projects/$id/inspections'
  id:
    | '__root__'
    | '/'
    | '/billing'
    | '/complete-profile'
    | '/confirm-email'
    | '/contractors'
    | '/dashboard'
    | '/design-system'
    | '/detect'
    | '/email-templates'
    | '/konzept'
    | '/language-test'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/setup-password'
    | '/system-settings'
    | '/upgrade'
    | '/admin/ai-training'
    | '/admin/reminder-settings'
    | '/admin/telegram'
    | '/admin/tester-feedback'
    | '/admin/users'
    | '/board-link/$token'
    | '/checkout/success'
    | '/history/$id'
    | '/slides/adm'
    | '/solutions/$defectType'
    | '/tickets/$id'
    | '/admin/'
    | '/checkout/'
    | '/history/'
    | '/projects/'
    | '/slides/'
    | '/solutions/'
    | '/tickets/'
    | '/projects/$id/analyses'
    | '/projects/$id/board'
    | '/projects/$id/floorplan'
    | '/projects/$id/settings'
    | '/projects/$id/team'
    | '/projects/$id/tickets'
    | '/ticket-submit/$id/completed'
    | '/projects/$id/'
    | '/ticket-submit/$id/'
    | '/projects/$id/inspections/$inspectionId'
    | '/projects/$id/inspections/new'
    | '/projects/$id/inspections/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BillingRoute: typeof BillingRoute
  CompleteProfileRoute: typeof CompleteProfileRoute
  ConfirmEmailRoute: typeof ConfirmEmailRoute
  ContractorsRoute: typeof ContractorsRoute
  DashboardRoute: typeof DashboardRoute
  DesignSystemRoute: typeof DesignSystemRoute
  DetectRoute: typeof DetectRoute
  EmailTemplatesRoute: typeof EmailTemplatesRoute
  KonzeptRoute: typeof KonzeptRoute
  LanguageTestRoute: typeof LanguageTestRoute
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SetupPasswordRoute: typeof SetupPasswordRoute
  SystemSettingsRoute: typeof SystemSettingsRoute
  UpgradeRoute: typeof UpgradeRoute
  AdminAiTrainingRoute: typeof AdminAiTrainingRoute
  AdminReminderSettingsRoute: typeof AdminReminderSettingsRoute
  AdminTelegramRoute: typeof AdminTelegramRoute
  AdminTesterFeedbackRoute: typeof AdminTesterFeedbackRoute
  AdminUsersRoute: typeof AdminUsersRoute
  BoardLinkTokenRoute: typeof BoardLinkTokenRoute
  CheckoutSuccessRoute: typeof CheckoutSuccessRoute
  HistoryIdRoute: typeof HistoryIdRoute
  SlidesAdmRoute: typeof SlidesAdmRoute
  SolutionsDefectTypeRoute: typeof SolutionsDefectTypeRoute
  TicketsIdRoute: typeof TicketsIdRoute
  AdminIndexRoute: typeof AdminIndexRoute
  CheckoutIndexRoute: typeof CheckoutIndexRoute
  HistoryIndexRoute: typeof HistoryIndexRoute
  ProjectsIndexRoute: typeof ProjectsIndexRoute
  SlidesIndexRoute: typeof SlidesIndexRoute
  SolutionsIndexRoute: typeof SolutionsIndexRoute
  TicketsIndexRoute: typeof TicketsIndexRoute
  ProjectsIdAnalysesRoute: typeof ProjectsIdAnalysesRoute
  ProjectsIdBoardRoute: typeof ProjectsIdBoardRoute
  ProjectsIdFloorplanRoute: typeof ProjectsIdFloorplanRoute
  ProjectsIdSettingsRoute: typeof ProjectsIdSettingsRoute
  ProjectsIdTeamRoute: typeof ProjectsIdTeamRoute
  ProjectsIdTicketsRoute: typeof ProjectsIdTicketsRoute
  TicketSubmitIdCompletedRoute: typeof TicketSubmitIdCompletedRoute
  ProjectsIdIndexRoute: typeof ProjectsIdIndexRoute
  TicketSubmitIdIndexRoute: typeof TicketSubmitIdIndexRoute
  ProjectsIdInspectionsInspectionIdRoute: typeof ProjectsIdInspectionsInspectionIdRoute
  ProjectsIdInspectionsNewRoute: typeof ProjectsIdInspectionsNewRoute
  ProjectsIdInspectionsIndexRoute: typeof ProjectsIdInspectionsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing': {
      id: '/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof BillingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/complete-profile': {
      id: '/complete-profile'
      path: '/complete-profile'
      fullPath: '/complete-profile'
      preLoaderRoute: typeof CompleteProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/confirm-email': {
      id: '/confirm-email'
      path: '/confirm-email'
      fullPath: '/confirm-email'
      preLoaderRoute: typeof ConfirmEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contractors': {
      id: '/contractors'
      path: '/contractors'
      fullPath: '/contractors'
      preLoaderRoute: typeof ContractorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/design-system': {
      id: '/design-system'
      path: '/design-system'
      fullPath: '/design-system'
      preLoaderRoute: typeof DesignSystemRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/detect': {
      id: '/detect'
      path: '/detect'
      fullPath: '/detect'
      preLoaderRoute: typeof DetectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/email-templates': {
      id: '/email-templates'
      path: '/email-templates'
      fullPath: '/email-templates'
      preLoaderRoute: typeof EmailTemplatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/konzept': {
      id: '/konzept'
      path: '/konzept'
      fullPath: '/konzept'
      preLoaderRoute: typeof KonzeptRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/language-test': {
      id: '/language-test'
      path: '/language-test'
      fullPath: '/language-test'
      preLoaderRoute: typeof LanguageTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/setup-password': {
      id: '/setup-password'
      path: '/setup-password'
      fullPath: '/setup-password'
      preLoaderRoute: typeof SetupPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system-settings': {
      id: '/system-settings'
      path: '/system-settings'
      fullPath: '/system-settings'
      preLoaderRoute: typeof SystemSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/upgrade': {
      id: '/upgrade'
      path: '/upgrade'
      fullPath: '/upgrade'
      preLoaderRoute: typeof UpgradeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/ai-training': {
      id: '/admin/ai-training'
      path: '/admin/ai-training'
      fullPath: '/admin/ai-training'
      preLoaderRoute: typeof AdminAiTrainingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/reminder-settings': {
      id: '/admin/reminder-settings'
      path: '/admin/reminder-settings'
      fullPath: '/admin/reminder-settings'
      preLoaderRoute: typeof AdminReminderSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/telegram': {
      id: '/admin/telegram'
      path: '/admin/telegram'
      fullPath: '/admin/telegram'
      preLoaderRoute: typeof AdminTelegramRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/tester-feedback': {
      id: '/admin/tester-feedback'
      path: '/admin/tester-feedback'
      fullPath: '/admin/tester-feedback'
      preLoaderRoute: typeof AdminTesterFeedbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/board-link/$token': {
      id: '/board-link/$token'
      path: '/board-link/$token'
      fullPath: '/board-link/$token'
      preLoaderRoute: typeof BoardLinkTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout/': {
      id: '/checkout/'
      path: '/checkout'
      fullPath: '/checkout/'
      preLoaderRoute: typeof CheckoutIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout/success': {
      id: '/checkout/success'
      path: '/checkout/success'
      fullPath: '/checkout/success'
      preLoaderRoute: typeof CheckoutSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history/': {
      id: '/history/'
      path: '/history'
      fullPath: '/history/'
      preLoaderRoute: typeof HistoryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history/$id': {
      id: '/history/$id'
      path: '/history/$id'
      fullPath: '/history/$id'
      preLoaderRoute: typeof HistoryIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/': {
      id: '/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof ProjectsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/slides/': {
      id: '/slides/'
      path: '/slides'
      fullPath: '/slides/'
      preLoaderRoute: typeof SlidesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/slides/adm': {
      id: '/slides/adm'
      path: '/slides/adm'
      fullPath: '/slides/adm'
      preLoaderRoute: typeof SlidesAdmRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/solutions/': {
      id: '/solutions/'
      path: '/solutions'
      fullPath: '/solutions/'
      preLoaderRoute: typeof SolutionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/solutions/$defectType': {
      id: '/solutions/$defectType'
      path: '/solutions/$defectType'
      fullPath: '/solutions/$defectType'
      preLoaderRoute: typeof SolutionsDefectTypeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tickets/': {
      id: '/tickets/'
      path: '/tickets'
      fullPath: '/tickets/'
      preLoaderRoute: typeof TicketsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tickets/$id': {
      id: '/tickets/$id'
      path: '/tickets/$id'
      fullPath: '/tickets/$id'
      preLoaderRoute: typeof TicketsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$id/': {
      id: '/projects/$id/'
      path: '/projects/$id'
      fullPath: '/projects/$id/'
      preLoaderRoute: typeof ProjectsIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$id/analyses': {
      id: '/projects/$id/analyses'
      path: '/projects/$id/analyses'
      fullPath: '/projects/$id/analyses'
      preLoaderRoute: typeof ProjectsIdAnalysesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$id/board': {
      id: '/projects/$id/board'
      path: '/projects/$id/board'
      fullPath: '/projects/$id/board'
      preLoaderRoute: typeof ProjectsIdBoardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$id/floorplan': {
      id: '/projects/$id/floorplan'
      path: '/projects/$id/floorplan'
      fullPath: '/projects/$id/floorplan'
      preLoaderRoute: typeof ProjectsIdFloorplanRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$id/settings': {
      id: '/projects/$id/settings'
      path: '/projects/$id/settings'
      fullPath: '/projects/$id/settings'
      preLoaderRoute: typeof ProjectsIdSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$id/team': {
      id: '/projects/$id/team'
      path: '/projects/$id/team'
      fullPath: '/projects/$id/team'
      preLoaderRoute: typeof ProjectsIdTeamRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$id/tickets': {
      id: '/projects/$id/tickets'
      path: '/projects/$id/tickets'
      fullPath: '/projects/$id/tickets'
      preLoaderRoute: typeof ProjectsIdTicketsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ticket-submit/$id/': {
      id: '/ticket-submit/$id/'
      path: '/ticket-submit/$id'
      fullPath: '/ticket-submit/$id/'
      preLoaderRoute: typeof TicketSubmitIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ticket-submit/$id/completed': {
      id: '/ticket-submit/$id/completed'
      path: '/ticket-submit/$id/completed'
      fullPath: '/ticket-submit/$id/completed'
      preLoaderRoute: typeof TicketSubmitIdCompletedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$id/inspections/': {
      id: '/projects/$id/inspections/'
      path: '/projects/$id/inspections'
      fullPath: '/projects/$id/inspections/'
      preLoaderRoute: typeof ProjectsIdInspectionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$id/inspections/$inspectionId': {
      id: '/projects/$id/inspections/$inspectionId'
      path: '/projects/$id/inspections/$inspectionId'
      fullPath: '/projects/$id/inspections/$inspectionId'
      preLoaderRoute: typeof ProjectsIdInspectionsInspectionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$id/inspections/new': {
      id: '/projects/$id/inspections/new'
      path: '/projects/$id/inspections/new'
      fullPath: '/projects/$id/inspections/new'
      preLoaderRoute: typeof ProjectsIdInspectionsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BillingRoute: BillingRoute,
  CompleteProfileRoute: CompleteProfileRoute,
  ConfirmEmailRoute: ConfirmEmailRoute,
  ContractorsRoute: ContractorsRoute,
  DashboardRoute: DashboardRoute,
  DesignSystemRoute: DesignSystemRoute,
  DetectRoute: DetectRoute,
  EmailTemplatesRoute: EmailTemplatesRoute,
  KonzeptRoute: KonzeptRoute,
  LanguageTestRoute: LanguageTestRoute,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SetupPasswordRoute: SetupPasswordRoute,
  SystemSettingsRoute: SystemSettingsRoute,
  UpgradeRoute: UpgradeRoute,
  AdminAiTrainingRoute: AdminAiTrainingRoute,
  AdminReminderSettingsRoute: AdminReminderSettingsRoute,
  AdminTelegramRoute: AdminTelegramRoute,
  AdminTesterFeedbackRoute: AdminTesterFeedbackRoute,
  AdminUsersRoute: AdminUsersRoute,
  BoardLinkTokenRoute: BoardLinkTokenRoute,
  CheckoutSuccessRoute: CheckoutSuccessRoute,
  HistoryIdRoute: HistoryIdRoute,
  SlidesAdmRoute: SlidesAdmRoute,
  SolutionsDefectTypeRoute: SolutionsDefectTypeRoute,
  TicketsIdRoute: TicketsIdRoute,
  AdminIndexRoute: AdminIndexRoute,
  CheckoutIndexRoute: CheckoutIndexRoute,
  HistoryIndexRoute: HistoryIndexRoute,
  ProjectsIndexRoute: ProjectsIndexRoute,
  SlidesIndexRoute: SlidesIndexRoute,
  SolutionsIndexRoute: SolutionsIndexRoute,
  TicketsIndexRoute: TicketsIndexRoute,
  ProjectsIdAnalysesRoute: ProjectsIdAnalysesRoute,
  ProjectsIdBoardRoute: ProjectsIdBoardRoute,
  ProjectsIdFloorplanRoute: ProjectsIdFloorplanRoute,
  ProjectsIdSettingsRoute: ProjectsIdSettingsRoute,
  ProjectsIdTeamRoute: ProjectsIdTeamRoute,
  ProjectsIdTicketsRoute: ProjectsIdTicketsRoute,
  TicketSubmitIdCompletedRoute: TicketSubmitIdCompletedRoute,
  ProjectsIdIndexRoute: ProjectsIdIndexRoute,
  TicketSubmitIdIndexRoute: TicketSubmitIdIndexRoute,
  ProjectsIdInspectionsInspectionIdRoute:
    ProjectsIdInspectionsInspectionIdRoute,
  ProjectsIdInspectionsNewRoute: ProjectsIdInspectionsNewRoute,
  ProjectsIdInspectionsIndexRoute: ProjectsIdInspectionsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
